import { SingleValue } from 'react-select';

import { Gateway } from 'types/gateway';
import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { useGateways } from 'gateways/hooks/useGateways';

import { GatewaySelect } from 'gateways/components/GatewaySelect/GatewaySelect';

import { Placeholder } from './SuggestionInput';
import { filterIds } from '../service';
import { useDataWidgetFiltersInputState } from '../context';

type GatewayFilterInputProps = Pick<DataWidgetFiltersInput, 'id' | 'value'>;

export function GatewayFilterInput({ id, value }: GatewayFilterInputProps) {
  const { filters, updateFilter } = useDataWidgetFiltersInputState();

  const gatewayIds = filterIds('gateway_id', filters);

  const { data: gateways, isInitialLoading } = useGateways({
    params: { gateway_ids: gatewayIds, limit: gatewayIds.length },
    enabled: Boolean(gatewayIds.length),
    keepPreviousData: true,
  });

  if (!gateways && isInitialLoading) {
    return Placeholder;
  }

  function handleGatewayChange(gateway: SingleValue<Gateway>) {
    if (!gateway) {
      return;
    }

    updateFilter(id, { value: gateway.id });
  }

  return (
    <GatewaySelect
      defaultValue={gateways?.data.find(({ id }) => id === value)}
      onChange={handleGatewayChange}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: 'auto',
        }),
      }}
    />
  );
}
